module.exports = __webpack_public_path__ + "static/media/11.5266b137.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/eyebrowes/11.png
// module id = 1196
// module chunks = 0